module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-204.5b458566.svg";